import request from '@/utils/request'

/**
 * 我的推广页面数据
 *
 * @export
 * @returns
 */
export function pageData() {
  return request({
    url: '/Api/Personal/Marketing/PageData',
    method: 'post'
  })
}

/**
 * 推广用户列表
 *
 * @param {*} pageIndex 当前页码
 * @param {*} pageSize  当前页码
 * @export
 * @returns
 */
export function userList({ pageIndex, pageSize }) {
  return request({
    url: `/Api/Personal/Marketing/UserList?pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'post'
  })
}

/**
 * 提现申请
 *
 * @param {*} pageIndex 当前页码
 * @param {*} pageSize  当前页码
 * @export
 * @returns
 */
export function alipay(data) {
  return request({
    url: '/Api/Personal/Marketing/Apply',
    method: 'post',
    data: data
  })
}

/**
 * 提现记录
 *
 * @param {*} pageIndex 当前页码
 * @param {*} pageSize  当前页码
 * @export
 * @returns
 */
export function marketingRecord({ sd, ed, pageIndex, pageSize }) {
  return request({
    url: `/Api/Personal/Marketing/Record?sd=${sd}&ed=${ed}&pageIndex=${pageIndex}&pageSize=${pageSize}`,
    method: 'post'
  })
}
